export enum CREDITO_FISCAL_TYPES {
    CCF_SET_VIEW = 'CCF_SET_VIEW',
    CCF_SET_FORM_CLIENTE = 'CCF_SET_FORM_CLIENTE',
    CCF_HANDLE_ERRORS_CLIENTE = 'CCF_HANDLE_ERRORS_CLIENTE',
    CCF_SET_FORM_PRODUCTO = 'CCF_SET_FORM_PRODUCTO',
    CCF_HANDLE_ERRORS_PRODUCTO = 'CCF_HANDLE_ERRORS_PRODUCTO',
    CCF_SET_FORM_CLIENTE_FELES = 'CCF_SET_FORM_CLIENTE_FELES',
    CCF_HANDLE_ERRORS_CLIENTE_FELES = 'CCF_HANDLE_ERRORS_CLIENTE_FELES',
    
    CCF_SET_PRODUCTOS = 'CCF_SET_PRODUCTOS',
    CCF_SET_PRODUCTO_EDIT = 'CCF_SET_PRODUCTO_EDIT',
    CCF_SET_PRODUCTO_INDEX = 'CCF_SET_PRODUCTO_INDEX',

    CCF_ACTIVE_MODAL_EDITAR_PRODUCTO = 'CCF_ACTIVE_MODAL_EDITAR_PRODUCTO',
    CCF_ACTIVE_MODAL_ELIMINAR_PRODUCTO = 'CCF_ACTIVE_MODAL_ELIMINAR_PRODUCTO',
    CCF_ACTIVE_MODAL_QUITAR_TODO = 'CCF_ACTIVE_MODAL_QUITAR_TODO',
    CCF_ACTIVE_MODAL_EMITIR = 'CCF_ACTIVE_MODAL_EMITIR',
    CCF_ACTIVE_MODAL_EMITIDO = 'CCF_ACTIVE_MODAL_EMITIDO',
    CCF_ACTIVE_MODAL_MAS_OPCIONES = 'CCF_ACTIVE_MODAL_MAS_OPCIONES',
    CCF_ACTIVE_MODAL_ENVIAR_CORREO = 'CCF_ACTIVE_MODAL_ENVIAR_CORREO',
    CCF_ACTIVE_MODAL_IMPRIMIR = 'CCF_ACTIVE_MODAL_IMPRIMIR',
    CCF_ACTIVE_MODAL_ANULAR = 'CCF_ACTIVE_MODAL_ANULAR',
    CCF_ACTIVE_MODAL_ANULADO = 'CCF_ACTIVE_MODAL_ANULADO',

    CCF_SET_QR_CODE = 'CCF_SET_QR_CODE',
    CCF_SET_RESPONSE_EMITIR = 'CCF_SET_RESPONSE_EMITIR',

    CCF_SET_CALCULOS_PRODUCTO = 'CCF_SET_CALCULOS_PRODUCTO',
    CCF_SET_CALCULOS_GENERALES = 'CCF_SET_CALCULOS_GENERALES',

    CCF_RESTART_FORM_PRODUCTO = 'CCF_RESTART_FORM_PRODUCTO',
    CCF_RESTART_ALL = 'CCF_RESTART_ALL',
    CCF_SET_CLIENTE_ENCONTRADO = 'CCF_SET_CLIENTE_ENCONTRADO',
    CCF_ACTIVE_MODAL_CLIENTE_ENCONTRADO = 'CCF_ACTIVE_MODAL_CLIENTE_ENCONTRADO',
    CCF_SET_TABLE_PRODUCTOS = 'CCF_SET_TABLE_PRODUCTOS',
    CCF_SET_RETENCION_RENTA = 'CCF_SET_RETENCION_RENTA',
    CCF_ACTIVE_NOTA_REMISION = 'CCF_ACTIVE_NOTA_REMISION',
    CCF_NOTAS_REMISION_ENCONTRADAS = 'CCF_NOTAS_REMISION_ENCONTRADAS',
    CCF_NOTAS_REMISION_ASOCIADAS = 'CCF_NOTAS_REMISION_ASOCIADAS',
    CCF_ACTIVE_LOADER_NOTAS_REMISION = 'CCF_ACTIVE_LOADER_NOTAS_REMISION',

    CCF_ACTIVE_ASOCIAR_FELES = 'CCF_ACTIVE_ASOCIAR_FELES',
    CCF_FORMOBSERVACIONES_HANDLE_CHANGE = 'CCF_FORMOBSERVACIONES_HANDLE_CHANGE',
}
